module.exports = __webpack_public_path__ + "img/vsk.9fa0b69.png";